import { Grid, Paper } from '@mui/material';
import { useSnackbar } from 'notistack';
import { SubmitHandler } from 'react-hook-form';
import { useMutation } from 'react-query';
import { useNavigate, useParams } from 'react-router';
import * as api from '../../api/app/monitoredStateApi';
import { AssetFullPathHeader } from '../../components/core/AssetFullPathHeader/AssetFullPathHeader';
import { PageContent } from '../../components/core/PageContent/PageContent';
import { AssetDetailTabValues, MonitoredPanelValues } from '../../types/app/asset.types';
import { MonitoredStateInputs } from '../../types/app/monitoredState.types';
import { dictionary } from '../../utils/core/dictionary';
import { paths } from '../../utils/core/routes';
import { MonitoredStateForm } from './MonitoredStateForm';
import { useStyles } from './MonitoredStateForm.styles';

export function MonitoredStateCreate() {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const { parentId } = useParams();
  const { mutate: mutateCreateMonitoredState } = useMutation(api.createMonitoredState);

  const handleOnSubmit: SubmitHandler<MonitoredStateInputs> = (data: MonitoredStateInputs) => {
    data.parentAssetId = Number(parentId);
    mutateCreateMonitoredState(
      { ...data },
      {
        onSuccess: () => {
          enqueueSnackbar(dictionary.MONITORED_STATE_CREATED, { variant: 'success' });
          navigate(`${paths.ASSETS_DETAIL}/${parentId}`, {
            state: {
              tabValue: AssetDetailTabValues.MONITORED_VALUES,
              panelValue: MonitoredPanelValues.MONITORED_STATE,
            },
          });
        },
        onError: (result: any) => {
          enqueueSnackbar(`${result}`, { variant: 'error' });
        },
      },
    );
  };

  return (
    <>
      <AssetFullPathHeader
        finalTitle={dictionary.MONITORED_STATE_CREATE}
        parentId={Number(parentId)}
      />
      <PageContent>
        <Grid container spacing={1}>
          <Grid item xs={12} md={8} lg={4}>
            <Paper className={classes.paper}>
              <MonitoredStateForm
                onSubmit={handleOnSubmit}
                onBack={() =>
                  navigate(`${paths.ASSETS_DETAIL}/${parentId}`, {
                    state: {
                      tabValue: AssetDetailTabValues.MONITORED_VALUES,
                      panelValue: MonitoredPanelValues.MONITORED_STATE,
                    },
                  })
                }
              />
            </Paper>
          </Grid>
        </Grid>
      </PageContent>
    </>
  );
}
